import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { OpenSquashService } from '../../shared/services/open-squash-service';

@Component({
  selector: 'app-add-player-to-group-component',
  imports: [CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule],
  templateUrl: './add-player-to-group-component.html',
  styleUrl: './add-player-to-group-component.scss'
})
export class AddPlayerToGroupComponent {
  private dialogRef = inject(MatDialogRef<AddPlayerToGroupComponent>);
  private fb = inject(FormBuilder);
  private data = inject(MAT_DIALOG_DATA);

  category = this.data?.categoryType ?? 'sin-categoría';
  group = this.data?.groupName ?? 'sin-grupo';

  private openSquashService = inject(OpenSquashService);

  form: FormGroup = this.fb.group({
    playerId: ['', Validators.required],
  });

  submit() {
    if (this.form.valid) {
      this.openSquashService.addPlayerToGroup(this.category, this.group, this.form.get('playerId')?.value).subscribe(() => {
        this.dialogRef.close(this.form.value);
      });
    }
  }

  exit() {
    this.dialogRef.close(null);
  }
}
